import type { TextBox } from "store/features/memeGenerator/types";
import { Color } from "./Color/Color";
import { Delete } from "./Delete/Delete";
import { Font } from "./Font/Font";
import { FontStyle } from "./FontStyle/FontStyle";
import { Keyboard } from "./Keyboard/Keyboard";

interface OptionsProps {
    textBox: TextBox;
}

export const Options = ({ textBox }: OptionsProps) => {
    return (
        <div className="flex items-center justify-between gap-2">
            <Color textBox={textBox} />
            <Font textBox={textBox} />
            <Keyboard textBoxId={textBox.id} />
            <FontStyle textBox={textBox} />
            <Delete textBoxId={textBox.id} />
        </div>
    );
};
